import { RefObject, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TwoColTemplate from '@gym-templates/TwoColTemplate/TwoColTemplate';
import { AlertType } from '@gym-atoms/Alert/Alert';
import { Card } from 'primereact/card';
import GymChainAccessCategoryInfoTemplate from '../../templates/GymChainAccessCategoryInfo/GymChainAccessCategoryInfo';

interface chainIdType {
  chainId: string;
}

const MainColumn = (props: { alertRef: RefObject<AlertType> }) => {
  const { accessCategoryId, chainId } = useParams<{ accessCategoryId: string; chainId: string }>();
  const { t } = useTranslation();
  return (
    <Card className="pt30 pl40 pr40 pb30">
      <GymChainAccessCategoryInfoTemplate
        type="new"
        alertRef={props.alertRef}
        alertMessage={t('ADD_NEW_GYM_ACCESS_CATEGORY.ALERT_MESSAGE_SUCCESS')}
      />
    </Card>
  );
};

const AddNewGymChainAccessCategoryPage = () => {
  const { t } = useTranslation();
  const alertRef = useRef<AlertType>(null);
  const history = useHistory();
  const { chainId } = useParams<chainIdType>();

  return (
    <TwoColTemplate
      title={t('ADD_NEW_GYM_ACCESS_CATEGORY.PAGE_TITLE')}
      gymChainId={+chainId}
      col1={<MainColumn alertRef={alertRef} />}
      alertRef={alertRef}
      backButtonHandler={() => history.push(`/gymChains/${chainId}/gymChainAccessCategories`)}
    />
  );
};

export default AddNewGymChainAccessCategoryPage;
